import type { EventEnvelope } from 'ProdantixSdk/core/types';

export interface QueueOverflow {
  dropped: EventEnvelope[];
}

export class EventQueue {
  private events: EventEnvelope[] = [];

  constructor(
    private readonly maxSize: number,
    private readonly onOverflow?: (overflow: QueueOverflow) => void,
  ) {}

  get size(): number {
    return this.events.length;
  }

  enqueue(event: EventEnvelope): void {
    this.events.push(event);
    this.enforceCap();
  }

  restore(events: EventEnvelope[]): void {
    this.events.push(...events);
    this.enforceCap();
  }

  requeue(events: EventEnvelope[]): void {
    this.events.unshift(...events);
    this.enforceCap();
  }

  drain(limit?: number): EventEnvelope[] {
    const count = limit === undefined ? this.events.length : Math.min(limit, this.events.length);
    return this.events.splice(0, count);
  }

  snapshot(): EventEnvelope[] {
    return [...this.events];
  }

  private enforceCap(): void {
    if (this.events.length <= this.maxSize) {
      return;
    }
    const dropped = this.events.splice(0, this.events.length - this.maxSize);
    this.onOverflow?.({ dropped });
  }
}
